import { type PropsWithChildren } from "react";
import { Label } from "ui";

interface Props {
  prompt: string;
  id: string;
  required?: boolean;
  error?: string;
}

export function BaseQuestion(props: PropsWithChildren<Props>) {
  return (
    <div className="w-full flex flex-col gap-2">
      <div className="">
        <Label className="inline" htmlFor={props.id}>
          {props.prompt}
        </Label>
        {props.required && (
          <span className="ml-1 text-red-500 leading-none">*</span>
        )}
      </div>
      <div className="w-full">{props.children}</div>
      {props.error && (
        <p className="text-sm text-destructive mt-1">{props.error}</p>
      )}
    </div>
  );
}
